/**
 * External dependencies
 */
import { get, omit, forOwn, omitBy, values } from 'lodash';

/**
 * Internal
 */
import { createReducer, appendToEditsLog } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
	{},
	{
		[actions.EDIT_DASHBOARD_LAYOUT]: (state, action) => {
			const id = action.payload.id || '';
			const layout = action.payload.layout;
			const newEditLogs = appendToEditsLog(get(state, id), layout);

			return {
				...state,
				[id]: newEditLogs,
			};
		},
		[actions.RESET_DASHBOARD_LAYOUT]: (state, action) => {
			const id = action.payload.id || '';
			return omit(state, id);
		},

		//
		// Deleted widgets need to also be removed from edited widgets
		// if they remain; the server will throw constraint violation errors
		//
		[actions.DELETE_REPORT_SUCCESS]: (state, action) => {
			let c = { ...state };
			const widgetId = get(action, ['payload', ['reportId']]);
			forOwn(state, (edits) => {
				forOwn(edits, (layout) => {
					layout.items = values(omitBy(layout.items, { widget: widgetId }));
				});
			});
			return c;
		},


	},
);
